import React from "react";
import Head from "next/head";

const PrivacyPolicy = () => {
  return (
    <div className="w-full md:mt-10 mt-8">
      <div className="max-w-screen-xl mx-auto md:px-8 px-4 break-words overflow-hidden">
        <Head>
          <meta charSet="utf-8" />
          <title>Privacy Policy | BoloSign</title>
          <meta
            name="description"
            content="BoloSign helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
          />
          <meta name="geo.region" content="IN" />
          <meta name="geo.position" content="22.351115;78.667743" />
          <meta name="ICBM" content="22.351115, 78.667743" />
          <meta name="author" content="BoloSign" />
          <meta name="publisher" content="BoloSign " />
          <meta
            name="robots"
            content="INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
          />
          <link
            rel="canonical"
            href="https://www.bolosign.com/privacy-policy/"
          />

          <meta
            property="og:url"
            content="https://www.bolosign.com/privacy-policy/"
          />
          <meta property="og:type" content="website" />
          <meta property="og:title" content="Privacy Policy | BoloSign" />
          <meta
            property="og:description"
            content="BoloSign helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
          />
          <meta
            property="og:image"
            content="https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
          />

          <meta name="twitter:card" content="summary_large_image" />
          <meta property="twitter:domain" content="https://bolosign.com" />
          <meta
            property="twitter:url"
            content="https://www.bolosign.com/privacy-policy/"
          />
          <meta
            name="twitter:title"
            content="BoloSign helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
          />
          <meta
            name="twitter:description"
            content="BoloSign helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
          />
          <meta
            name="twitter:image"
            content="https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
          />
        </Head>
        <h4 className="text-4xl font-semibold mb-4 capitalize">
          Privacy Policy
        </h4>
        <div>
          <p className="mb-2">Effective date: 05/02/2025</p>
          <p className="mb-2">Introduction</p>
          <p className="mb-2">Welcome to&nbsp;Closer Innovation Labs Corp.</p>
          <p className="mb-2">
            Closer Innovation Labs Corp.&nbsp;(“us”, “we”, or “our”)
            operates&nbsp;
            <a className="text-blue-500" href="https://www.boloforms.com/">
              https://www.boloforms.com/
            </a>
            and or mobile application (“Application”) located at
            <a
              className="text-blue-500"
              href="https://apps.apple.com/in/app/bolosign-upload-sign-send/id6717583531"
            >
              {" "}
              Apple Store{" "}
            </a>
            and
            <a
              className="text-blue-500"
              href="https://play.google.com/store/apps/details?id=com.boloforms.signature&pcampaignid=web_share"
            >
              {" "}
              Playstore{" "}
            </a>
          </p>
          <p className="mb-2">
            having registered address at 8 The Green, Dover, Delware, 19902,
            United States.
          </p>
          <p className="mb-2">
            Our Privacy Policy governs your visit to&nbsp;
            <a className="text-blue-500" href="https://www.boloforms.com/">
              https://www.boloforms.com/
            </a>
            , and explains how we collect, safeguard and disclose information
            that results from your use of our Service.{" "}
          </p>
          <p className="mb-2">
            We use your data to provide and improve Service. By using Service,
            you agree to the collection and use of information in accordance
            with this policy. Unless otherwise defined in this Privacy Policy,
            the terms used in this Privacy Policy have the same meanings as in
            our Terms and Conditions.
          </p>
          <p className="mb-2">
            Our Terms and Conditions (“Terms”) govern all use of our Service and
            together with the Privacy Policy constitutes your agreement with us
            (“agreement”).
          </p>
          <p className="mb-2">Definitions</p>
          <p className="mb-2">
            SERVICE&nbsp;means the&nbsp;
            <a className="text-blue-500" href="https://www.boloforms.com/">
              https://www.boloforms.com/
            </a>{" "}
            website&nbsp; and or mobile application (“Application”) located at
            <a
              className="text-blue-500"
              href="https://apps.apple.com/in/app/bolosign-upload-sign-send/id6717583531"
            >
              {" "}
              Apple Store{" "}
            </a>
            and
            <a
              className="text-blue-500"
              href="https://play.google.com/store/apps/details?id=com.boloforms.signature&pcampaignid=web_share"
            >
              {" "}
              Playstore{" "}
            </a>
            operated by&nbsp;Closer Innovation Labs Corp.
          </p>
          <p className="mb-2">
            PERSONAL DATA&nbsp;means data about a living individual who can be
            identified from those data (or from those and other information
            either in our possession or likely to come into our possession).
          </p>
          <p className="mb-2">
            USAGE DATA&nbsp;is data collected automatically either generated by
            the use of Service or from Service infrastructure itself (for
            example, the duration of a page visit).
          </p>
          <p className="mb-2">
            COOKIES&nbsp;are small files stored on your device (computer or
            mobile device).
          </p>
          <p className="mb-2">
            INTERNATIONAL DATA TRANSFER POLICY&nbsp;We recognize that many
            jurisdictions impose restrictions on the transfer of personal data
            outside their borders. To ensure compliance with these requirements,
            we will rely on the following legal bases for international data
            transfers: Adequacy Decisions: We may transfer personal data to
            countries that the European Commission or relevant authorities have
            determined to provide an adequate level of data protection. Standard
            Contractual Clauses (SCCs): For countries that do not have an
            adequacy decision, we will implement Standard Contractual Clauses
            approved by the European Commission or other relevant authorities as
            a safeguard for international data transfers. Binding Corporate
            Rules (BCRs): Where appropriate, we may rely on Binding Corporate
            Rules that have been approved by data protection authorities to
            ensure a consistent level of protection for personal data
            transferred within our corporate group. Explicit Consent: In cases
            where other legal bases are not available, we may obtain explicit
            consent from the data subject before transferring their personal
            data internationally, provided that the data subject is fully
            informed of the potential risks associated with such transfers.
          </p>
          <p className="mb-2">
            DATA CONTROLLER&nbsp;means a natural or legal person who (either
            alone or jointly or in common with other persons) determines the
            purposes for which and the manner in which any personal data are, or
            are to be, processed. For the purpose of this Privacy Policy, we are
            a Data Controller of your data.
          </p>
          <p className="mb-2">
            DATA PROCESSORS (OR SERVICE PROVIDERS)&nbsp;means any natural or
            legal person who processes the data on behalf of the Data
            Controller. We may use the services of various Service Providers in
            order to process your data more effectively.
          </p>
          <p className="mb-2">
            DATA SUBJECT&nbsp;is any living individual who is the subject of
            Personal Data.
          </p>
          <p className="mb-2">
            THE USER&nbsp;is the individual using our Service. The User
            corresponds to the Data Subject, who is the subject of Personal
            Data.
          </p>
          <p className="mb-2">Information Collection and Use</p>
          <p className="mb-2">
            We collect several different types of information for various
            purposes to provide and improve our Service to you.
          </p>
          <p className="mb-2">Types of Data Collected</p>
          <p className="mb-2">
            Personal Data
            <br />
            While using our Service, we may ask you to provide us with certain
            personally identifiable information that can be used to contact or
            identify you (“Personal Data”). Personally identifiable information
            may include, but is not limited to:
          </p>
          <p className="mb-2">Email address</p>
          <p className="mb-2">First name and last name</p>
          <p className="mb-2">Phone number</p>
          <p className="mb-2">Signature</p>
          <p className="mb-2">
            Address, State, Province, ZIP/Postal code, City
          </p>
          <p className="mb-2">Cookies and Usage Data</p>
          <p className="mb-2">
            We may use your Personal Data to contact you with newsletters,
            marketing or promotional materials and other information that may be
            of interest to you. You may opt out of receiving any, or all, of
            these communications from us&nbsp;by following the unsubscribe link.
          </p>
          <p className="mb-2">
            Usage Data
            <br />
            We may also collect information that your br/owser sends whenever
            you visit our Service or when you access Service by or through a
            mobile device (“Usage Data”).
          </p>
          <p className="mb-2">
            {`This Usage Data may include information such as your computer's
          Internet Protocol address (e.g. IP address), browser type, browser
          version, the pages of our Service that you visit, the time and date of
          your visit, the time spent on those pages, unique device identifiers
          and other diagnostic data.`}
          </p>
          <p className="mb-2">
            When you access Service with a mobile device, this Usage Data may
            include information such as the type of mobile device you use, your
            mobile device unique ID, the IP address of your mobile device, your
            mobile operating system, the type of mobile Internet br/owser you
            use, unique device identifiers and other diagnostic data.
          </p>
          <p className="mb-2">
            Location Data
            <br />
            We may use and store information about your location if you give us
            permission to do so (“Location Data”). We use this data to provide
            features of our Service, to improve and customize our Service.
          </p>
          <p className="mb-2">
            You can enable or disable location services when you use our Service
            at any time by way of your device settings.
          </p>
          <p className="mb-2">
            Tracking Cookies Data
            <br />
            We use cookies and similar tracking technologies to track the
            activity on our Service and we hold certain information.
          </p>
          <p className="mb-2">
            Cookies are files with a small amount of data which may include an
            anonymous unique identifier. Cookies are sent to your br/owser from
            a website and stored on your device. Other tracking technologies are
            also used such as beacons, tags and scripts to collect and track
            information and to improve and analyze our Service.
          </p>
          <p className="mb-2">
            You can instruct your br/owser to refuse all cookies or to indicate
            when a cookie is being sent. However, if you do not accept cookies,
            you may not be able to use some portions of our Service.
          </p>
          <p className="mb-2">Examples of Cookies we use:</p>
          <p className="mb-2">
            Session Cookies:&nbsp;We use Session Cookies to operate our Service.
          </p>
          <p className="mb-2">
            Preference Cookies:&nbsp;We use Preference Cookies to remember your
            preferences and various settings.
          </p>
          <p className="mb-2">
            Security Cookies:&nbsp;We use Security Cookies for security
            purposes.
          </p>
          <p className="mb-2">
            Advertising Cookies:&nbsp;Advertising Cookies are used to serve you
            with advertisements that may be relevant to you and your interests.
          </p>
          <p className="mb-2">
            Other Data
            <br />
            While using our Service, we may also collect the following
            information: sex, age, date of birth, place of birth, passport
            details, citizenship, registration at place of residence and actual
            address, telephone number (work, mobile), details of documents on
            education, qualification, professional training, employment
            agreements, non-disclosure agreements, information on bonuses and
            compensation, information on marital status, family members, social
            security (or other taxpayer identification) number, office location
            and other data.{" "}
          </p>
          <p className="mb-2">Use of Data</p>
          <p className="mb-2">
            Closer Innovation Labs Corp.&nbsp;uses the collected data for
            various purposes:
          </p>
          <p className="mb-2">to provide and maintain our Service;</p>
          <p className="mb-2">to notify you about changes to our Service; </p>
          <p className="mb-2">
            to allow you to participate in interactive features of our Service
            when you choose to do so;{" "}
          </p>
          <p className="mb-2">to provide customer support; </p>
          <p className="mb-2">
            to gather analysis or valuable information so that we can improve
            our Service;{" "}
          </p>
          <p className="mb-2">to monitor the usage of our Service;</p>
          <p className="mb-2">
            to detect, prevent and address technical issues;
          </p>
          <p className="mb-2">
            to fulfill any other purpose for which you provide it;
          </p>
          <p className="mb-2">
            to carry out our obligations and enforce our rights arising from any
            contracts entered into between you and us, including for billing and
            collection;
          </p>
          <p className="mb-2">
            to provide you with notices about your account and/or subscription,
            including expiration and renewal notices, email-instructions, etc.;
          </p>
          <p className="mb-2">
            to provide you with news, special offers and general information
            about other goods, services and events which we offer that are
            similar to those that you have already purchased or enquired about
            unless you have opted not to receive such information;
          </p>
          <p className="mb-2">
            in any other way we may describe when you provide the information;
          </p>
          <p className="mb-2">for any other purpose with your consent. </p>
          <p className="mb-2">Retention of Data</p>
          <p className="mb-2">
            We will retain your Personal Data only for as long as is necessary
            for the purposes set out in this Privacy Policy. We will retain and
            use your Personal Data to the extent necessary to comply with our
            legal obligations (for example, if we are required to retain your
            data to comply with applicable laws), resolve disputes, and enforce
            our legal agreements and policies. Until and unless the customer
            request us to delete the data we don&apos;t delete it, if requested
            we delete the data after 30 days .
          </p>
          <p className="mb-2">
            We will also retain Usage Data for internal analysis purposes. Usage
            Data is generally retained for a shorter period, except when this
            data is used to strengthen the security or to improve the
            functionality of our Service, or we are legally obligated to retain
            this data for longer time periods.
          </p>
          <p className="mb-2">Transfer of Data</p>
          <p className="mb-2">
            Your information, including Personal Data, may be transferred to –
            and maintained on – computers located outside of your state,
            province, country or other governmental jurisdiction where the data
            protection laws may differ from those of your jurisdiction.
          </p>
          <p className="mb-2">
            If you are located outside United States and choose to provide
            information to us, please note that we transfer the data, including
            Personal Data, to United States and process it there.
          </p>
          <p className="mb-2">
            Your consent to this Privacy Policy followed by your submission of
            such information represents your agreement to that transfer.
          </p>
          <p className="mb-2">
            Closer Innovation Labs Corp.&nbsp;will take all the steps reasonably
            necessary to ensure that your data is treated securely and in
            accordance with this Privacy Policy and no transfer of your Personal
            Data will take place to an organisation or a country unless there
            are adequate controls in place including the security of your data
            and other personal information.
          </p>
          <p className="mb-2">Disclosure of Data</p>
          <p className="mb-2">
            We may disclose personal information that we collect, or you
            provide:
          </p>
          <p className="mb-2">
            Disclosure for Law Enforcement.
            <br />
            Under certain circumstances, we may be required to disclose your
            Personal Data if required to do so by law or in response to valid
            requests by public authorities.
          </p>
          <p className="mb-2">
            Business Transaction.
            <br />
            If we or our subsidiaries are involved in a merger, acquisition or
            asset sale, your Personal Data may be transferred.
          </p>
          <p className="mb-2">Other cases.</p>
          {/* <p className="mb-2">to our subsidiaries and affiliates;</p> */}
          <p className="mb-2">Security of Data</p>
          <p className="mb-2">
            The security of your data is important to us but remember that no
            method of transmission over the Internet or method of electronic
            storage is 100% secure. While we strive to use commercially
            acceptable means to protect your Personal Data, we cannot guarantee
            its absolute security.
          </p>

          <p className="mb-2">
            Your Data Protection Rights Under General Data Protection Regulation
            (GDPR)
          </p>
          <p className="mb-2">
            If you are a resident of the European Union (EU) and European
            Economic Area (EEA), you have certain data protection rights,
            covered by GDPR. – See more at{" "}
            <a
              className="text-blue-500"
              href="https://eur-lex.europa.eu/eli/reg/2016/679/oj"
            >
              https://eur-lex.europa.eu/eli/reg/2016/679/oj
            </a>{" "}
          </p>
          <p className="mb-2">
            We aim to take reasonable steps to allow you to correct, amend,
            delete, or limit the use of your Personal Data.
          </p>
          <p className="mb-2">
            If you wish to be informed what Personal Data we hold about you and
            if you want it to be removed from our systems, please email us at{" "}
            <a className="text-blue-500" href="mailto:support@boloforms.com">
              support@boloforms.com
            </a>
            .{" "}
          </p>
          <p className="mb-2">
            In certain circumstances, you have the following data protection
            rights:
          </p>
          <p className="mb-2">
            the right to access, update or to delete the information we have on
            you;
          </p>
          <p className="mb-2">
            the right of rectification. You have the right to have your
            information rectified if that information is inaccurate or
            incomplete;
          </p>
          <p className="mb-2">
            the right to object. You have the right to object to our processing
            of your Personal Data;
          </p>
          <p className="mb-2">
            the right of restriction. You have the right to request that we
            restrict the processing of your personal information;
          </p>
          <p className="mb-2">
            the right to data portability. You have the right to be provided
            with a copy of your Personal Data in a structured, machine-readable
            and commonly used format;
          </p>
          <p className="mb-2">
            the right to withdraw consent.&nbsp;You also have the right to
            withdraw your consent at any time where we rely on your consent to
            process your personal information;
          </p>
          <p className="mb-2">
            Please note that we may ask you to verify your identity before
            responding to such requests. Please note, we may not able to provide
            Service without some necessary data.
          </p>
          <p className="mb-2">
            You have the right to complain to a Data Protection Authority about
            our collection and use of your Personal Data. For more information,
            please contact your local data protection authority in the European
            Economic Area (EEA).
          </p>
          <p className="mb-2">
            Your Data Protection Rights under the California Privacy Protection
            Act (CalOPPA)
          </p>
          <p className="mb-2">
            CalOPPA is the first state law in the nation to require commercial
            websites and online services to post a privacy policy. The law's
            reach stretches well beyond California to require a person or
            company in the United States (and conceivable the world) that
            operates websites collecting personally identifiable information
            from California consumers to post a conspicuous privacy policy on
            its website stating exactly the information being collected and
            those individuals with whom it is being shared, and to comply with
            this policy. – See more at:
            <a
              className="text-blue-500"
              href="https://consumercal.org/about-cfc/cfc-education-foundation/california-online-privacy-protection-act-caloppa-3/"
            >
              https://consumercal.org/about-cfc/cfc-education-foundation/california-online-privacy-protection-act-caloppa-3/
            </a>
          </p>
          <p className="mb-2">
            According to CalOPPA we agree to the following:
          </p>
          <p className="mb-2">users can visit our site anonymously;</p>
          <p className="mb-2">
            our Privacy Policy link includes the word "Privacy", and can easily
            be found on the page specified above on the home page of our
            website;
          </p>
          <p className="mb-2">
            users will be notified of any privacy policy changes on our Privacy
            Policy Page;
          </p>
          <p className="mb-2">
            users are able to change their personal information by emailing us
            at{" "}
            <a className="text-blue-500" href="mailto:support@boloforms.com">
              support@boloforms.com
            </a>
            .{" "}
          </p>
          <p className="mb-2">Our Policy on "Do Not Track" Signals:</p>
          <p className="mb-2">
            We honor Do Not Track signals and do not track, plant cookies, or
            use advertising when a Do Not Track browser mechanism is in place.
            Do Not Track is a preference you can set in your web br/owser to
            inform websites that you do not want to be tracked.{" "}
          </p>
          <p className="mb-2">
            You can enable or disable Do Not Track by visiting the Preferences
            or Settings page of your web br/owser.
          </p>
          <p className="mb-2">
            Your Data Protection Rights under the California Consumer Privacy
            Act (CCPA)
          </p>
          <p className="mb-2">
            If you are a California resident, you are entitled to learn what
            data we collect about you, ask to delete your data and not to sell
            (share) it. To exercise your data protection rights, you can make
            certain requests and ask us:
          </p>
          <p className="mb-2">
            What personal information we have about you. If you make this
            request, we will return to you:
          </p>
          <p className="mb-2">
            The categories of personal information we have collected about you.
          </p>
          <p className="mb-2">
            The categories of sources from which we collect your personal
            information.
          </p>
          <p className="mb-2">
            The business or commercial purpose for collecting or selling your
            personal information.
          </p>
          <p className="mb-2">
            The categories of third parties with whom we share personal
            information.
          </p>
          <p className="mb-2">
            The specific pieces of personal information we have collected about
            you.
          </p>
          <p className="mb-2">
            A list of categories of personal information that we have sold,
            along with the category of any other company we sold it to. If we
            have not sold your personal information, we will inform you of that
            fact.
          </p>
          <p className="mb-2">
            A list of categories of personal information that we have disclosed
            for a business purpose, along with the category of any other company
            we shared it with.
          </p>
          <p className="mb-2">
            Please note, you are entitled to ask us to provide you with this
            information up to two times in a rolling twelve-month period. When
            you make this request, the information provided may be limited to
            the personal information we collected about you in the previous
            12&nbsp;months.
          </p>
          <p className="mb-2">
            To delete your personal information. If you make this request, we
            will delete the personal information we hold about you as of the
            date of your request from our records and direct any service
            providers to do the same. In some cases, deletion may be
            accomplished through de-identification of the information. If you
            choose to delete your personal information, you may not be able to
            use certain functions that require your personal information to
            operate.{" "}
          </p>
          {/* <p className="mb-2">
          To stop selling your personal information. If you submit a request to
          stop selling your personal information, we will stop selling it. If
          you are a California resident, to opt-out of the sale of your personal
          information, click "Do Not Sell My Personal Information" at the bottom
          of our home page to submit your request.
        </p> */}
          <p className="mb-2">
            Please note, if you ask us to delete, it may impact your experience
            with us, and you may not be able to participate in certain programs
            or membership services which require the usage of your personal
            information to function. But in no circumstances, we will
            discriminate against you for exercising your rights.
          </p>
          <p className="mb-2">
            To exercise your California data protection rights described above,
            please send your request(s) by one of the following means:
          </p>
          <p className="mb-2">
            By email:{" "}
            <a className="text-blue-500" href="mailto:support@boloforms.com">
              support@boloforms.com
            </a>
          </p>
          <p className="mb-2">
            Your data protection rights, described above, are covered by the
            CCPA, short for the California Consumer Privacy Act. To find out
            more, visit the official California Legislative Information website.
            The CCPA took effect on 01/01/2020.{" "}
          </p>
          <p className="mb-2">Service Providers</p>
          <p className="mb-2">
            We may employ third party companies and individuals to facilitate
            our Service (“Service Providers”), provide Service on our behalf,
            perform Service-related services or assist us in analysing how our
            Service is used.
          </p>
          <p className="mb-2">
            These third parties have access to your Personal Data only to
            perform these tasks on our behalf and are obligated not to disclose
            or use it for any other purpose. No mobile information will be
            shared with third parties/affiliates for marketing/promotional
            purposes. All the above categories exclude text messaging originator
            opt-in data and consent; this information will not be shared with
            any third parties
          </p>
          <p className="mb-2">AI Data Processing Services</p>
          <p className="mb-2">
            We utilize artificial intelligence services from trusted partners to
            process and analyze documents and data submitted through our
            Service. Our primary AI processing partners include:
          </p>

          <p className="mb-2">
            OpenAI
            <br />
            We use OpenAI's services to analyze documents and enhance our
            document processing capabilities. For more information about
            OpenAI's privacy practices, please visit:{" "}
            <a className="text-blue-500" href="https://openai.com/privacy">
              https://openai.com/privacy
            </a>
          </p>

          <p className="mb-2">
            Anthropic Claude
            <br />
            We utilize Anthropic's Claude AI services for document analysis and
            processing. For more information about Anthropic's privacy
            practices, please visit:{" "}
            <a
              className="text-blue-500"
              href="https://www.anthropic.com/privacy"
            >
              https://www.anthropic.com/privacy
            </a>
          </p>

          <p className="mb-2">
            Google Gemini
            <br />
            We employ Google's Gemini AI services for document processing and
            analysis. For more information about Google's privacy practices,
            please visit:{" "}
            <a
              className="text-blue-500"
              href="https://policies.google.com/privacy"
            >
              https://policies.google.com/privacy
            </a>
          </p>

          <p className="mb-2">
            These AI services help us improve our Service by:
            <br />
            • Analyzing document content and structure
            <br />
            • Enhancing document processing accuracy
            <br />
            • Improving our service features and capabilities
            <br />• Providing better user experience
          </p>

          <p className="mb-2">
            When you submit documents to our Service, they may be processed by
            one or more of these AI services. We ensure that all data processing
            by our AI partners complies with applicable data protection laws and
            our privacy commitments. While these partners maintain high security
            standards, we recommend being mindful of sensitive information in
            documents you submit for processing.
          </p>
          <p className="mb-2">Analytics</p>
          <p className="mb-2">
            We may use third-party Service Providers to monitor and analyze the
            use of our Service.
          </p>
          <p className="mb-2">
            Google Analytics
            <br />
            Google Analytics is a web analytics service offered by Google that
            tracks and reports website traffic. Google uses the data collected
            to track and monitor the use of our Service. This data is shared
            with other Google services. Google may use the collected data to
            contextualise and personalise the ads of its own advertising
            network.
          </p>
          <p className="mb-2">
            For more information on the privacy practices of Google, please
            visit the Google Privacy Terms web page:{" "}
            <a
              className="text-blue-500"
              href="https://policies.google.com/privacy?hl=en"
            >
              https://policies.google.com/privacy?hl=en
            </a>
          </p>
          <p className="mb-2">
            {` We also encourage you to review the Google's policy for safeguarding
          your data: `}
            <a
              className="text-blue-500"
              href="https://support.google.com/analytics/answer/6004245"
            >
              https://support.google.com/analytics/answer/6004245
            </a>
            .
          </p>
          <p className="mb-2">
            Firebase
            <br />
            Firebase is analytics service provided by Google Corp.
          </p>
          <p className="mb-2">
            You may opt-out of certain Firebase features through your mobile
            device settings, such as your device advertising settings or by
            following the instructions provided by Google in their Privacy
            Policy:{" "}
            <a
              className="text-blue-500"
              href="https://policies.google.com/privacy?hl=en"
            >
              https://policies.google.com/privacy?hl=en
            </a>
          </p>
          <p className="mb-2">
            For more information on what type of information Firebase collects,
            please visit the Google Privacy Terms web page:{" "}
            <a
              className="text-blue-500"
              href="https://policies.google.com/privacy?hl=en"
            >
              https://policies.google.com/privacy?hl=en
            </a>
          </p>
          <p className="mb-2">
            Fathom Analytics
            <br />
            Fathom Analytics is analytics service provided by Conva Ventures
            Corp. You can find their Privacy Policy here:{" "}
            <a className="text-blue-500" href="https://usefathom.com/privacy/">
              https://usefathom.com/privacy/
            </a>
          </p>
          <p className="mb-2">
            Piwik / Matomo
            <br />
            Piwik or Matomo is a web analytics service. You can visit their
            Privacy Policy page here:
            <a
              className="text-blue-500"
              href="https://matomo.org/privacy-policy"
            >
              https://matomo.org/privacy-policy
            </a>
          </p>
          <p className="mb-2">
            Clicky
            <br />
            Clicky is a web analytics service. Read the Privacy Policy for
            Clicky here:{" "}
            <a className="text-blue-500" href="https://clicky.com/terms">
              https://clicky.com/terms
            </a>
          </p>
          <p className="mb-2">
            Cloudflare analytics
            <br />
            Cloudflare analytics is a web analytics service operated by
            Cloudflare Corp. Read the Privacy Policy here:{" "}
            <a
              className="text-blue-500"
              href="https://www.cloudflare.com/privacypolicy/"
            >
              https://www.cloudflare.com/privacypolicy/
            </a>{" "}
          </p>
          <p className="mb-2">
            Segment.io
            <br />
            Segment.io is a web traffic analysis tool. You can read the Privacy
            Policy for Segment.io here:
            <a
              className="text-blue-500"
              href="https://segment.com/legal/privacy/"
            >
              https://segment.com/legal/privacy/
            </a>
            .
          </p>
          <p className="mb-2">
            Statcounter
            <br />
            Statcounter is a web traffic analysis tool. You can read the Privacy
            Policy for Statcounter here:{" "}
            <a
              className="text-blue-500"
              href="https://statcounter.com/about/legal/"
            >
              https://statcounter.com/about/legal/
            </a>
          </p>
          <p className="mb-2">
            Flurry Analytics
            <br />
            Flurry Analytics service is provided by Yahoo! Corp.
          </p>
          <p className="mb-2">
            {`You can opt-out from Flurry Analytics service to prevent Flurry
          Analytics from using and sharing your information by visiting the
          Flurry's Opt-out page: `}
            <a
              className="text-blue-500"
              href="https://dev.flurry.com/secure/optOut.do"
            >
              https://dev.flurry.com/secure/optOut.do
            </a>
          </p>
          <p className="mb-2">
            For more information on the privacy practices and policies of
            Yahoo!, please visit their Privacy Policy page:
            <a
              className="text-blue-500"
              href="https://policies.yahoo.com/us/en/yahoo/privacy/policy/index.htm"
            >
              https://policies.yahoo.com/us/en/yahoo/privacy/policy/index.htm
            </a>
          </p>
          <p className="mb-2">
            Mixpanel
            <br />
            Mixpanel is provided by Mixpanel Corp.
          </p>
          <p className="mb-2">
            You can prevent Mixpanel from using your information for analytics
            purposes by opting-out. To opt-out of Mixpanel service, please visit
            this page:{" "}
            <a className="text-blue-500" href="https://mixpanel.com/optout/">
              https://mixpanel.com/optout/
            </a>
          </p>
          <p className="mb-2">
            For more information on what type of information Mixpanel collects,
            please visit the Terms of Use page of Mixpanel:{" "}
            <a className="text-blue-500" href="https://mixpanel.com/terms/">
              https://mixpanel.com/terms/
            </a>
          </p>
          <p className="mb-2">
            Unity Analytics
            <br />
            Unity Analytics is provided by Unity Technologies.
          </p>
          <p className="mb-2">
            For more information on what type of information Unity Analytics
            collects, please visit their Privacy Policy page:{" "}
            <a
              className="text-blue-500"
              href="https://unity3d.com/legal/privacy-policy"
            >
              https://unity3d.com/legal/privacy-policy
            </a>
          </p>
          <p className="mb-2">
            Ackee
            <br />
            Ackee is a web traffic analysis tool.
          </p>
          <p className="mb-2">
            For more information on what type of information Ackee collects,
            please visit their Terms of Service page:{" "}
            <a
              className="text-blue-500"
              href="https://electerious.com/terms_of_service.html"
            >
              https://electerious.com/terms_of_service.html
            </a>
          </p>
          <p className="mb-2">
            Simple Analytics
            <br />
            Simple Analytics is a web-based analysis tool
          </p>
          <p className="mb-2">
            For more information on what type of information Ackee collects,
            please visit their Privacy Policy page:{" "}
            <a
              className="text-blue-500"
              href="https://simpleanalytics.com/privacy-policy"
            >
              https://simpleanalytics.com/privacy-policy
            </a>
          </p>
          <p className="mb-2">
            PostHog
            <br />
            PostHog is a product analytics platform built for the modern
            enterprise, with the differentiators of being open source and having
            a br/oader view of the tools needed to make a product successful.
          </p>
          <p className="mb-2">
            For more information about PostHog, please visit their Privacy
            Policy:{" "}
            <a className="text-blue-500" href="https://posthog.com/privacy">
              https://posthog.com/privacy
            </a>
          </p>
          <p className="mb-2">
            Yodo1
            <br />
            Yodo1 is a service provided by Yodo1, Ltd.
          </p>
          <p className="mb-2">
            For more information on what type of information Yodo1 collects,
            please visit their Privacy Policy page:{" "}
            <a className="text-blue-500" href="https://www.yodo1.com/privacy">
              https://www.yodo1.com/privacy
            </a>
          </p>
          <p className="mb-2">Weblate</p>
          <p className="mb-2">
            For more information on what type of information Weblate collects,
            please visit their Privacy Policy page:{" "}
            <a className="text-blue-500" href="https://weblate.org/en/terms/">
              https://weblate.org/en/terms/
            </a>
          </p>
          <p className="mb-2">CI/CD tools</p>
          <p className="mb-2">
            We may use third-party Service Providers to automate the development
            process of our Service.{" "}
          </p>
          <p className="mb-2">GitHub</p>
          <p className="mb-2">GitHub is provided by GitHub, Corp.</p>
          <p className="mb-2">
            GitHub is a development platform to host and review code, manage
            projects, and build software.
          </p>
          <p className="mb-2">
            For more information on what data GitHub collects for what purpose
            and how the protection of the data is ensured, please visit GitHub
            Privacy Policy page:{" "}
            <a
              className="text-blue-500"
              href="https://help.github.com/en/articles/github-privacy-statement"
            >
              https://help.github.com/en/articles/github-privacy-statement
            </a>
            .
          </p>
          <p className="mb-2">GitLab CI/CD</p>
          <p className="mb-2">GitLab CI/CD is provided by GitLab, Corp.</p>
          <p className="mb-2">
            GitLab CI (Continuous Integration) service is a part of GitLab that
            build and test the software whenever developer pushes code to
            application.{" "}
          </p>
          <p className="mb-2">
            GitLab CD (Continuous Deployment) is a software service that places
            the changes of every code in the production which results in every
            day deployment of production.{" "}
          </p>
          <p className="mb-2">
            For more information on what data GitLab CI/CD collects for what
            purpose and how the protection of the data is ensured, please visit
            GitLab CI/CD Privacy Policy page:{" "}
            <a
              className="text-blue-500"
              href="https://about.gitlab.com/privacy/"
            >
              https://about.gitlab.com/privacy/
            </a>
            .
          </p>
          <p className="mb-2">Advertising</p>
          <p className="mb-2">
            We may use third-party Service Providers to show advertisements to
            you to help support and maintain our Service.
          </p>
          <p className="mb-2">
            Google AdSense DoubleClick Cookie
            <br />
            {`Google, as a third party vendor, uses cookies to serve ads on our
          Service. Google's use of the DoubleClick cookie enables it and its
          partners to serve ads to our users based on their visit to our Service
          or other websites on the Internet.`}
          </p>
          <p className="mb-2">
            You may opt out of the use of the DoubleClick Cookie for
            interest-based advertising by visiting the Google Ads Settings web
            page:{" "}
            <a
              className="text-blue-500"
              href="https://www.google.com/ads/preferences/"
            >
              http://www.google.com/ads/preferences/
            </a>
          </p>
          <p className="mb-2">Behavioral Remarketing</p>
          <p className="mb-2">
            Closer Innovation Labs Corp.&nbsp;uses remarketing services to
            advertise on third party websites to you after you visited our
            Service. We and our third-party vendors use cookies to inform,
            optimise and serve ads based on your past visits to our Service.
          </p>
          <p className="mb-2">
            Google Ads (AdWords)
            <br />
            Google Ads (AdWords) remarketing service is provided by Google Corp.
          </p>
          <p className="mb-2">
            You can opt-out of Google Analytics for Display Advertising and
            customize the Google Display Network ads by visiting the Google Ads
            Settings page:{" "}
            <a
              className="text-blue-500"
              href="https://www.google.com/settings/ads"
            >
              http://www.google.com/settings/ads
            </a>
          </p>
          <p className="mb-2">
            Google also recommends installing the Google Analytics Opt-out
            br/owser Add-on –{" "}
            <a
              className="text-blue-500"
              href="https://tools.google.com/dlpage/gaoptout"
            >
              https://tools.google.com/dlpage/gaoptout
            </a>{" "}
            – for your web br/owser. Google Analytics Opt-out br/owser Add-on
            provides visitors with the ability to prevent their data from being
            collected and used by Google Analytics.
          </p>
          <p className="mb-2">
            For more information on the privacy practices of Google, please
            visit the Google Privacy Terms web page:{" "}
            <a
              className="text-blue-500"
              href="https://policies.google.com/privacy?hl=en"
            >
              https://policies.google.com/privacy?hl=en
            </a>
          </p>
          <p className="mb-2">
            Twitter
            <br />
            Twitter remarketing service is provided by Twitter Corp.
          </p>
          <p className="mb-2">
            {`You can opt-out from Twitter's interest-based ads by following their
          instructions: `}
            <a
              className="text-blue-500"
              href="https://support.twitter.com/articles/20170405"
            >
              https://support.twitter.com/articles/20170405
            </a>
          </p>
          <p className="mb-2">
            You can learn more about the privacy practices and policies of
            Twitter by visiting their Privacy Policy page:
            <a className="text-blue-500" href="https://twitter.com/privacy">
              https://twitter.com/privacy
            </a>
          </p>
          <p className="mb-2">
            Facebook
            <br />
            Facebook remarketing service is provided by Facebook Corp.
          </p>
          <p className="mb-2">
            You can learn more about interest-based advertising from Facebook by
            visiting this page:{" "}
            <a
              className="text-blue-500"
              href="https://www.facebook.com/help/164968693837950"
            >
              https://www.facebook.com/help/164968693837950
            </a>
          </p>
          <p className="mb-2">
            {` To opt-out from Facebook's interest-based ads, follow these
          instructions from Facebook: `}
            <a
              className="text-blue-500"
              href="https://www.facebook.com/help/568137493302217"
            >
              https://www.facebook.com/help/568137493302217
            </a>
          </p>
          <p className="mb-2">
            Facebook adheres to the Self-Regulatory Principles for Online
            Behavioural Advertising established by the Digital Advertising
            Alliance. You can also opt-out from Facebook and other participating
            companies through the Digital Advertising Alliance in the USA{" "}
            <a
              className="text-blue-500"
              href="http://www.aboutads.info/choices/"
            >
              http://www.aboutads.info/choices/
            </a>
            , the Digital Advertising Alliance of Canada in Canada{" "}
            <a className="text-blue-500" href="http://youradchoices.ca/">
              http://youradchoices.ca/
            </a>{" "}
            or the European Interactive Digital Advertising Alliance in Europe{" "}
            <a
              className="text-blue-500"
              href="http://www.youronlinechoices.eu/"
            >
              http://www.youronlinechoices.eu/
            </a>
            , or opt-out using your mobile device settings.
          </p>
          <p className="mb-2">
            {`For more information on the privacy practices of Facebook, please
          visit Facebook's Data Policy: `}
            <a
              className="text-blue-500"
              href="https://www.facebook.com/privacy/explanation"
            >
              https://www.facebook.com/privacy/explanation
            </a>
          </p>
          <p className="mb-2">Personal health infomation</p>
          <p>
            No personal health information (PHI) is collected, processed,
            stored, or transferred as part of our services.{" "}
          </p>
          <p className="mb-2">Payments</p>
          <p className="mb-2">
            We may provide paid products and/or services within Service. In that
            case, we use third-party services for payment processing (e.g.
            payment processors).
          </p>
          <p className="mb-2">
            We will not store or collect your payment card details. That
            information is provided directly to our third-party payment
            processors whose use of your personal information is governed by
            their Privacy Policy. These payment processors adhere to the
            standards set by PCI-DSS as managed by the PCI Security Standards
            Council, which is a joint effort of br/ands like Visa, Mastercard,
            American Express and Discover. PCI-DSS requirements help ensure the
            secure handling of payment information.
          </p>
          <p className="mb-2">The payment processors we work with are:</p>
          <p className="mb-2">
            PayPal or braintree:
            <br />
            Their Privacy Policy can be viewed at&nbsp;
            <a
              className="text-blue-500"
              href="https://www.paypal.com/webapps/mpp/ua/privacy-full"
            >
              https://www.paypal.com/webapps/mpp/ua/privacy-full
            </a>
          </p>
          <p className="mb-2">
            Stripe:
            <br />
            Their Privacy Policy can be viewed at:{" "}
            <a className="text-blue-500" href="https://stripe.com/us/privacy">
              https://stripe.com/us/privacy
            </a>
          </p>
          <p className="mb-2">Links to Other Sites</p>
          <p className="mb-2">
            {`Our Service may contain links to other sites that are not operated by
          us. If you click a third party link, you will be directed to that
          third party's site. We strongly advise you to review the Privacy
          Policy of every site you visit.`}
          </p>
          <p className="mb-2">
            We have no control over and assume no responsibility for the
            content, privacy policies or practices of any third party sites or
            services.
          </p>
          <p className="mb-2">{`Children&apos;s Privacy`}</p>
          <p className="mb-2">
            Our Services are not intended for use by children under the age of
            13 (&quot;Children&quot;).{" "}
          </p>
          <p className="mb-2">
            We do not knowingly collect personally identifiable information from
            Children under 13. If you become aware that a Child has provided us
            with Personal Data, please contact us. If we become aware that we
            have collected Personal Data from Children without verification of
            parental consent, we take steps to remove that information from our
            servers.
          </p>
          <p className="mb-2">Changes to This Privacy Policy</p>
          <p className="mb-2">
            We may update our Privacy Policy from time to time. We will notify
            you of any changes by posting the new Privacy Policy on this page.
          </p>
          <p className="mb-2">
            We will let you know via email and/or a prominent notice on our
            Service, prior to the change becoming effective and update
            "effective date" at the top of this Privacy Policy.
          </p>
          <p className="mb-2">
            You are advised to review this Privacy Policy periodically for any
            changes. Changes to this Privacy Policy are effective when they are
            posted on this page.
          </p>

          <p className="mb-2">
            Data Privacy Officer Our Data Privacy Officer (DPO) is responsible
            for overseeing questions in relation to this privacy policy and also
            for data assestment, data deletion, conduct risk assesment, monitor
            data security measure, investigate breaches. If you have any
            questions about this policy, including any requests to exercise your
            legal rights, please contact the DPO using the details set out
            below:
            <br />
            Name: Chirag Gupta
            <br />
            Email:
            <a className="text-blue-500" href="mailto:support@boloforms.com">
              support@boloforms.com
            </a>
          </p>
        </div>
        <p className="mb-2">Privacy Notice</p>
        <p className="mb-2">
          The data is collected indirectly from data subjects which gets saved
          in our database for proctection measuse for the end customer, we have
          also have access restriction in place for our organization as well.
        </p>

        <p className="mb-2">Consent Management Process</p>
        <p className="mb-2">
          Obtaining Consent: We obtain your consent for processing your personal
          data through clear and explicit methods, such as consent forms or
          checkboxes on our website or application.
        </p>

        <p className="mb-2">
          Modification of Consent: You can modify your consent preferences at
          any time by accessing your account settings on our website or
          application, or by contacting our Data Privacy Officer.
        </p>

        <p className="mb-2">
          Revocation of Consent: You have the right to revoke your consent at
          any time. To revoke your consent, please contact our Data Privacy
          Officer or update your preferences in your account settings. Once we
          receive notification that you have withdrawn your consent, we will no
          longer process your personal data for the purpose(s) to which you
          originally consented, unless we have another legitimate basis for
          doing so.
        </p>

        <p className="mb-2">Data Breach Reporting Process</p>

        <p className="mb-2">
          We have implemented procedures to deal with any suspected personal
          data breach and will notify you and any applicable regulator of a
          breach where we are legally required to do so.{" "}
        </p>

        <ul>
          <li>
            <strong>Detection and Assessment</strong>: Upon detecting a
            potential data breach, we will promptly assess the scope and impact
            of the breach.
          </li>
          <li>
            <strong>Containment and Recovery</strong>: We will take immediate
            steps to contain the breach and mitigate any potential harm to data
            subjects.
          </li>
          <li>
            <strong>Notification</strong>: If the breach is likely to result in
            a high risk to your rights and freedoms, we will notify you without
            undue delay. We will also notify the relevant supervisory authority
            within 72 hours of becoming aware of the breach, unless the breach
            is unlikely to result in a risk to your rights and freedoms.
          </li>
          <li>
            Investigation and Remediation: We will investigate the cause of the
            breach and take steps to prevent future occurrences.
          </li>

          <li>
            For any queries related to the protection of personal health
            information (PHI), please reach out to support@boloforms.
          </li>
        </ul>

        <p className="mb-2">Technical Control Measures and Compliance</p>
        <p className="mb-2">
          We implement robust technical control measures to protect your data:
        </p>
        <ul className="list-disc pl-8 mb-2">
          <li>
            Access Control: Strict role-based access controls and multi-factor
            authentication
          </li>
          <li>
            Encryption: Industry-standard encryption for data in transit and at
            rest
          </li>
          <li>
            Network Security: Advanced firewalls and intrusion detection systems
          </li>
          <li>
            Regular Security Audits: Continuous monitoring and vulnerability
            assessments
          </li>
        </ul>
        <p className="mb-2">
          We have been independently assessed and certified for compliance with:
        </p>
        <ul className="list-disc pl-8 mb-2">
          <li className="">SOC 2 Type I</li>
          <li>
            SOC 2 Type II
            {/* I standards for security, availability, and
          confidentiality */}
          </li>
          <li>
            ISO 27001:2013 certification for information security management
          </li>
          <li>
            Regular third-party penetration testing and security assessments
          </li>
        </ul>
        <p>
          You can see all our certifications from here :{" "}
          <a className="text-blue-500" href="https://security.boloforms.com">
            https://security.boloforms.com
          </a>
        </p>
        <br />

        <p className="mb-2" style={{ fontWeight: "bold" }}>
          Contact Us
        </p>
        <p className="mb-2">
          If you have any questions about this Privacy Policy, please contact
          us:
        </p>
        <p className="mb-2">
          By email:{" "}
          <a className="text-blue-500" href="mailto:support@boloforms.com">
            support@boloforms.com
          </a>
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
